import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=42dccc18&scoped=true"
import script from "./comment.vue?vue&type=script&lang=ts"
export * from "./comment.vue?vue&type=script&lang=ts"
import style0 from "./comment.vue?vue&type=style&index=0&id=42dccc18&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dccc18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42dccc18')) {
      api.createRecord('42dccc18', component.options)
    } else {
      api.reload('42dccc18', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=42dccc18&scoped=true", function () {
      api.rerender('42dccc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comment-edit/comment.vue"
export default component.exports